export default "__VITE_ASSET__uSZ$fWXr__"